var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          staticStyle: { width: "100%", "margin-top": "20px" },
          attrs: {
            data: _vm.list.value,
            "span-method": _vm.objectSpanMethod,
            border: "",
            "empty-text": "-",
          },
        },
        [
          _c("el-table-column", {
            attrs: { width: "200", prop: "code", label: "插件ID" },
          }),
          _c("el-table-column", { attrs: { prop: "name", label: "插件名称" } }),
          _c("el-table-column", {
            attrs: { prop: "descr", label: "更新说明" },
          }),
          _c("el-table-column", { attrs: { prop: "ver", label: "插件版本" } }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "fileMd5",
              label: "md5",
            },
          }),
          _c("el-table-column", {
            attrs: { prop: "appVer", label: "支持APP版本" },
          }),
          _c("el-table-column", {
            attrs: { prop: "sdkVer", label: "支持SDK版本" },
          }),
          _c("el-table-column", {
            attrs: { width: "200", prop: "createUser", label: "上传人/时间" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [_vm._v(_vm._s(scope.row.createUser))]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(scope.row.createTime))]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "操作" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "auth",
                            rawName: "v-auth",
                            value: "PLUGIN_MANAGE_PLUGIN_CONFIG_DEL",
                            expression: "'PLUGIN_MANAGE_PLUGIN_CONFIG_DEL'",
                          },
                        ],
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.del(scope.row.id)
                          },
                        },
                      },
                      [_vm._v("删除")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("ElementPagination", {
        staticStyle: { "margin-bottom": "20px" },
        attrs: {
          total: _vm.searchParams.total,
          current: _vm.searchParams.current,
          size: _vm.searchParams.size,
          pageSizes: [10, 20, 50, 100],
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }